import React from 'react';
import PlanTermAccordionSummary, {
  PlanTermAccordionSummaryProps,
} from './PlanTermAccordionSummary';
import Accordion from './Accordion';
import type { PlanTermProps } from '../context';
import AccordionDetails from './AccordionDetails';
import PlanTermContext from './context';
import PlanTermTimeline from './PlanTermTimeline';
import MoreSeeButton from './MoreSeeButton';

export type PlanTermAccordionProps = Omit<
  PlanTermAccordionSummaryProps,
  'onEditClick',
  'component',
> &
  PlanTermProps & {
    expanded?: boolean,
    readOnly?: boolean,
  };

const PlanTermAccordion = ({
  expanded: expandedProps,
  readOnly,
  skeleton,
  index,
  ...planTermProps
}: PlanTermAccordionProps) => {
  const [state] = React.useState(planTermProps);
  const [expanded, setExpanded] = React.useState(!!expandedProps);

  const handleChange = (event, expanded) =>
    !event.target.closest('*[expansion-disabled]') && setExpanded(expanded);

  const toggleExpanded = () => {
    setExpanded((prevState) => !prevState);
  };

  return (
    <PlanTermContext.Provider
      value={{
        planTerm: state,
        validity: {},
      }}
    >
      <Accordion expanded={expanded} onChange={handleChange}>
        <PlanTermAccordionSummary
          index={index}
          expanded={expanded}
          skeleton={skeleton}
          toggleExpanded={toggleExpanded}
        />
        <AccordionDetails>
          <PlanTermTimeline />
          <MoreSeeButton
            expanded={expanded}
            isShow={expanded}
            onClick={toggleExpanded}
          />
        </AccordionDetails>
      </Accordion>
    </PlanTermContext.Provider>
  );
};

export default PlanTermAccordion;
